// extracted by mini-css-extract-plugin
module.exports = {"font":"#212121","card":"card-module--card--1BthF","cardLink":"card-module--card-link--ROhUr","cardHover":"card-module--card-hover--yCAZL"};